<template>
    <div class="post-tags text-muted small" v-if="tags.length > 0">
        Từ khóa:
        <a v-for="tag in tags" :href="$root.url('post_tag', { slug : tag.slug, id : tag.id })"
           class="badge badge-light mr-1">{{ tag.name }}</a>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: 'PostTags',
        data() {
            return {
                tags: [],
                errors: []
            }
        },
        props: ['postId'],
        created() {
            let baseUri = process.env.MOVEEK_API_ENDPOINT;
            axios.get(baseUri + '/v1/tags?post.id=' + this.postId)
                .then(response => {
                    this.tags = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                });
        }
    }
</script>

<style scoped>
</style>